import { render, staticRenderFns } from "./account_add_dialog.vue?vue&type=template&id=267fc9a6&scoped=true"
import script from "./account_add_dialog.vue?vue&type=script&lang=ts"
export * from "./account_add_dialog.vue?vue&type=script&lang=ts"
import style0 from "./account_add_dialog.vue?vue&type=style&index=0&id=267fc9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267fc9a6",
  null
  
)

export default component.exports